<div
  class="main-container"
  [class.items-collection]="collection.type === HighlightedCollectionType.MenuItems"
  [class.wishlist-collection]="collection.type === HighlightedCollectionType.Wishlists"
  [class.vendors-collection]="
    collection.type === HighlightedCollectionType.Vendors || collection.type === HighlightedCollectionType.NewVendors
  "
  [class.reorder-collection]="collection.type === HighlightedCollectionType.ReOrder"
>
  <div class="title-section">
    <div class="title">{{ collection.title }}</div>
    <span class="badge" [style.background]="badge.backColor" [style.color]="badge.foreColor" *ngFor="let badge of collection.badges">
      {{ badge.text }}
    </span>
  </div>

  <div *ngIf="!isBrowser" class="content" #scrollElement>
    <div class="content-wrapper">
      <div class="featured-item" *ngFor="let collectionItem of collection.items">
        <ng-container *ngTemplateOutlet="featuredItem; context: collectionItem"></ng-container>
      </div>

      <div
        tappable
        class="add-new-wishlist-button"
        *ngIf="collection.type === HighlightedCollectionType.Wishlists"
        (click)="onAddNewWishlist()"
      >
        <ion-icon class="add-new-wishlist-button-icon" src="/assets/custom-icons/b-plus.svg"></ion-icon>
      </div>
    </div>
  </div>

  <div class="horizontal-list-container">
    <ng-container *ngIf="isBrowser">
      <div [id]="'prev-' + collectionIndex" class="horizontal-list-button btn-previous" tappable>
        <ion-icon class="horizontal-list-button-icon" name="chevron-back-outline"></ion-icon>
      </div>

      <swiper #swiper class="horizontal-list" [dir]="sliderScrollingDirection" [config]="sliderConfig">
        <ng-template swiperSlide *ngFor="let collectionItem of collection.items">
          <div tappable class="featured-item">
            <ng-container *ngTemplateOutlet="featuredItem; context: collectionItem"></ng-container>
          </div>

          <div
            tappable
            class="add-new-wishlist-button"
            *ngIf="collection.type === HighlightedCollectionType.Wishlists"
            (click)="onAddNewWishlist()"
          >
            <ion-icon class="add-new-wishlist-button-icon" src="/assets/custom-icons/b-plus.svg"></ion-icon>
          </div>
        </ng-template>
      </swiper>

      <div [id]="'next-' + collectionIndex" class="horizontal-list-button btn-next" tappable>
        <ion-icon class="horizontal-list-button-icon" name="chevron-forward-outline"></ion-icon>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #featuredItem let-vendorDetails="vendorDetails" let-itemDetails="itemDetails" let-genericDetails="genericDetails">
  <ng-container *ngIf="collection.type === HighlightedCollectionType.Wishlists">
    <app-router-link [path]="['wishlists']" [queryParams]="{ wishlistId: genericDetails.id }">
      <p class="featured-item-name">{{ genericDetails?.name }}</p>
      <p class="featured-item-description">{{ genericDetails.description }}</p>
    </app-router-link>
  </ng-container>

  <ng-container
    *ngIf="
      vendorDetails &&
      (collection.type === HighlightedCollectionType.Vendors ||
        collection.type === HighlightedCollectionType.NewVendors ||
        collection.type === HighlightedCollectionType.ReOrder)
    "
  >
    <app-router-link
      [path]="isBrowser && vendorDetails.slug ? ['vendors', vendorDetails.slug] : ['vendors', 'id', vendorDetails.id]"
      [preserveFragmentAndQueryParams]="true"
      [queryParams]="{
        sourceId: vendorDetails.id,
        sourceType: collection.type === HighlightedCollectionType.Vendors || collection.type === HighlightedCollectionType.NewVendors
          ? sponsoredVendorSourceType
          : reorderSourceType,
      }"
    >
      <div [attr.data-src]="vendorDetails.imageUrl" class="lazy-loading-image not-loaded animated-image">
        <div
          class="lazy-loading-image-content"
          [style.backgroundImage]="vendorDetails.imageUrl ? 'url(' + vendorDetails?.imageUrl + ')' : null"
        ></div>
      </div>

      <p class="featured-item-name">{{ vendorDetails.name }}</p>
      <p class="featured-item-description">{{ vendorDetails.description }}</p>
    </app-router-link>
  </ng-container>

  <ng-container *ngIf="itemDetails && collection.type === HighlightedCollectionType.MenuItems">
    <app-router-link
      [path]="
        isBrowser && vendorDetails.slug
          ? ['vendors', vendorDetails.slug, itemDetails.id]
          : ['vendors', 'id', vendorDetails.id, itemDetails.id]
      "
      [preserveFragmentAndQueryParams]="true"
      [queryParams]="{ sourceId: vendorDetails.id, sourceType: featuredItemSourceType }"
    >
      <div [attr.data-src]="itemDetails.imageUrl" class="lazy-loading-image not-loaded animated-image">
        <div
          class="lazy-loading-image-content"
          [style.backgroundImage]="itemDetails.imageUrl ? 'url(' + itemDetails.imageUrl + ')' : null"
        ></div>
      </div>

      <p class="featured-item-name">{{ itemDetails.name }}</p>

      <p class="featured-item-price">
        <ng-container *ngIf="itemDetails.price">
          <span>{{ itemDetails.price | localCurrency }}</span>
          <span class="retail" *ngIf="itemDetails.onSale">{{ itemDetails.retailPrice | localCurrency }}</span>
        </ng-container>

        <ng-container *ngIf="!itemDetails.price">
          <span *ngIf="!itemDetails.supportStartingPrice || !itemDetails.minimumCost">
            {{ "PRICE_ON_SELECTION" | translate }}
          </span>

          <ng-container *ngIf="itemDetails.supportStartingPrice && itemDetails.minimumCost">
            <span> {{ "FROM" | translate }} {{ itemDetails.minimumCost | localCurrency }} </span>
            <span class="retail" *ngIf="itemDetails.onSale">
              {{ "FROM" | translate }} {{ itemDetails.retailMinimumCost | localCurrency }}
            </span>
          </ng-container>
        </ng-container>
      </p>

      <p *ngIf="vendorDetails.name" class="featured-item-description">
        {{ vendorDetails.name }}
      </p>
    </app-router-link>
  </ng-container>
</ng-template>
